export const PREFIX = "web-store";
